import { FaUsers, FaUserPlus } from 'react-icons/fa6'
import AccountManager from '../accountManager/AccountManager'
import UsersPage from './UserPage'
import { useAppSelector } from '../../../hooks';
import { constraintConfig } from '../../../constraintConfig';
import { selectAuth } from '../../../features/authSlice';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

type LocationState = {
  activeTab?: string;
};

const UsersPageWrapper = () => {
  const { roleID } = useAppSelector(selectAuth);
  const location = useLocation();
  const locationState = location.state as LocationState | null;
  const [tabChange, setTabChange] = useState('');
  const [activeTab, setActiveTab] = useState('first');

  useEffect(() => {
    if (locationState?.activeTab === 'second') {
      setActiveTab('second');
      setTabChange('second');
    }
  }, [locationState]);

  const handleTabSelect = (selectedKey: any) => {
    setTabChange(selectedKey);
    setActiveTab(selectedKey);
  };
  
  return (
    <>
      <style>{`
        /* Compact pill-style group toggle */
        .ss-compact-pill-group {
          display: inline-flex;
          border-radius: 20px !important;
          overflow: hidden;
          background-color: #eff6ff;
          padding: 2px;
          gap: 2px;
        }
        .ss-compact-pill-btn {
          font-size: 12px !important;
          font-weight: 500 !important;
          padding: 5px 14px !important;
          border-radius: 16px !important;
          border: none !important;
          background-color: transparent !important;
          color: #555 !important;
          transition: all 0.2s ease;
          height: auto !important;
          line-height: 1.4 !important;
          white-space: nowrap;
        }
        .ss-compact-pill-btn:hover {
          background-color: rgba(13, 202, 240, 0.1) !important;
        }
        .ss-compact-pill-btn.active {
          background-color: #009ef7 !important;
          color: #fff !important;
          box-shadow: 0 2px 4px rgba(0, 158, 247, 0.3);
        }
      `}</style>
      
      <div className='d-flex align-items-center mb-4'>
        <div className='ss-compact-pill-group' role='group' aria-label='User list tabs'>
          <button
            type='button'
            className={`ss-compact-pill-btn ${activeTab === 'first' ? 'active' : ''}`}
            onClick={() => handleTabSelect('first')}
          >
            <FaUsers className="me-1" />
            <span className='d-none d-sm-inline'>Active Users</span>
            <span className='d-sm-none'>Active</span>
          </button>
          
          {(roleID === constraintConfig.roleID.role2 || roleID === constraintConfig.roleID.role4) && (
            <button
              type='button'
              className={`ss-compact-pill-btn ${activeTab === 'second' ? 'active' : ''}`}
              onClick={() => handleTabSelect('second')}
            >
              <FaUserPlus className="me-1" />
              <span className='d-none d-sm-inline'>Onboarding Requests</span>
              <span className='d-sm-none'>Onboard</span>
            </button>
          )}
        </div>
      </div>

      {activeTab === 'first' && <UsersPage tabChange={tabChange} />}
      {activeTab === 'second' && <AccountManager tabChange={tabChange} />}
    </>
  )
}

export default UsersPageWrapper